// =============================================
// Own Domain Guard (2026-08-23) — wykluczenie WLASNEJ domeny projektu
// z SERP researchu i ze zrodel enrichmentu.
//
// PROBLEM: artykuly map rankuja juz w Google na wlasne frazy. Przy REGENERACJI
// pipeline dostawal w SERP stara wersje tego samego artykulu (czytal sam
// siebie), a weryfikacja claimow potrafila zacytowac wlasna domene w stopce
// Zrodla (incydent whiteever.pl 2026-08-23). Decyzja wlasciciela: domena
// projektu NIGDY nie jest zrodlem ani materialem SERP.
//
// Fail-open: brak website_id / blad DB => null => zero filtrowania
// (standalone i mapy bez domeny dzialaja jak dotad).
// =============================================

import { supabase } from "@/integrations/supabase/client";

const cache = new Map<string, string | null>();

/** Hostname bez www, lowercase; null gdy nie da sie sparsowac. */
export function hostnameOf(url: string): string | null {
  if (!url || typeof url !== "string") return null;
  try {
    const u = new URL(/^https?:\/\//i.test(url) ? url : `https://${url}`);
    return u.hostname.replace(/^www\./i, "").toLowerCase() || null;
  } catch {
    return null;
  }
}

/** Czy URL nalezy do domeny (lacznie z subdomenami)? ownDomain=null => false. */
export function isSameDomain(url: string, ownDomain: string | null): boolean {
  if (!ownDomain) return false;
  const h = hostnameOf(url);
  return h !== null && (h === ownDomain || h.endsWith(`.${ownDomain}`));
}

/** Domena wlasna mapy (websites.url przez thematic_maps.website_id), cache per mapId. */
export async function getOwnDomain(mapId: string | undefined): Promise<string | null> {
  if (!mapId) return null;
  if (cache.has(mapId)) return cache.get(mapId)!;
  let domain: string | null = null;
  try {
    const { data: map } = await (supabase as any)
      .from("thematic_maps")
      .select("website_id")
      .eq("id", mapId)
      .maybeSingle();
    if (map?.website_id) {
      const { data: site } = await (supabase as any)
        .from("websites")
        .select("url")
        .eq("id", map.website_id)
        .maybeSingle();
      if (site?.url) domain = hostnameOf(site.url);
    }
  } catch {
    domain = null; // fail-open
  }
  cache.set(mapId, domain);
  return domain;
}
